module.exports = __webpack_public_path__ + "public/img/pt_br.c4b4b267.png";